import ReactSelect from 'dashboard/components/ReactSelect';
import { NodeConditions } from 'dashboard/models/graph';

export interface ConnectedConditionsSelectProps {
  value: string;
  returnName: boolean;
  onChange: (value: string) => void;
}

const ConnectedConditionsSelect = ({
  value,
  onChange,
  returnName,
}: ConnectedConditionsSelectProps) => {
  const options = Object.values(NodeConditions).map((condition, idx) => {
    return { label: String(condition), value: String(returnName ? condition : idx) };
  });

  return (
    <ReactSelect
      size='md'
      value={value}
      isMulti={false}
      isSearchable={true}
      portal={true}
      options={options}
      onChange={onChange}
    />
  );
};

export default ConnectedConditionsSelect;
